// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"1da6db23","116":"192abd90","135":"ac001e86","453":"f30133a9","652":"d08ffc5c","724":"550f22b4","854":"473dd63b","956":"d87daa1b"}[chunkId] + ".chunk.js";
};